export enum EnsaioAliquotaEventsEnum {
  Removida = 'aliquotas-removidas',
}

export enum CategoriaEnsaioAliquotaEnum {
  PULP = 'PULP',
  METALLIC = 'METALLIC',
}
